import { CountrySelector } from '@/modules/localization';

if (document.getElementById('CountrySelector')) {
    new CountrySelector(document.getElementById('CountrySelector'));
}

document.querySelectorAll('.js-localization-select').forEach((select) => {
    select.addEventListener('change', () => {
        const form = select.closest('.js-localization-form');
        if (form) form.submit();
    });
});
